import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#31344A",
      "fill-rule": "evenodd",
      d: "M14.266 2.484a1.184 1.184 0 1 0 0 2.368 1.184 1.184 0 0 0 0-2.368Zm-2.754 1.184a2.754 2.754 0 1 1 5.508 0 2.754 2.754 0 0 1-5.508 0ZM4.579 14.298a2.497 2.497 0 1 0 0 4.993 2.497 2.497 0 0 0 0-4.993ZM.512 16.794a4.067 4.067 0 1 1 8.134 0 4.067 4.067 0 0 1-8.134 0ZM17.705 14.298a2.497 2.497 0 1 0 0 4.993 2.497 2.497 0 0 0 0-4.993Zm-4.066 2.496a4.067 4.067 0 1 1 8.133 0 4.067 4.067 0 0 1-8.133 0Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#31344A",
      "fill-rule": "evenodd",
      d: "M11.233 7.086a.528.528 0 0 0-.454.138L7.24 10.585a.529.529 0 0 0 .118.85 6.022 6.022 0 0 1 3.255 5.36H9.83h.785a.528.528 0 0 0 1.056 0v-.002a7.065 7.065 0 0 0-2.49-5.395.785.785 0 0 1-.033-1.167l1.271-1.208a.785.785 0 0 1 1.14.06 4.746 4.746 0 0 0 3.527 1.676h-.005v.785l.014-.785h-.008a.527.527 0 0 0-.006-1.056c-1.176 0-2.054-.63-2.597-1.177a5.46 5.46 0 0 1-.858-1.135.528.528 0 0 0-.392-.305Zm-.697-1.488a2.097 2.097 0 0 1 2.476 1.056l.003.006.025.043a3.885 3.885 0 0 0 .557.717c.397.4.897.713 1.483.713a2.098 2.098 0 0 1 0 4.196h-.014a6.317 6.317 0 0 1-4.129-1.634l-.107.102a8.636 8.636 0 0 1 2.41 5.998h-.785.785a2.097 2.097 0 0 1-4.196 0v-.002a4.452 4.452 0 0 0-2.407-3.964l-.002-.001a2.097 2.097 0 0 1-.476-3.38l3.538-3.362c.238-.226.525-.393.839-.488Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }